// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Code, Grid, Text } from "@radix-ui/themes";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { THINKING_MESSAGES } from "./ResultsView";

interface ChatMessageData {
  message_id: string;
  type: "idk" | "assistant";
  content: string;
  timestamp: number;
  sourceUrl?: string;
  evidence?: string;
  subType?: string;
}

interface ChatMessageProps {
  message: ChatMessageData;
  setIsThinking?: (isThinking: boolean) => void;
}

export const RobotIcon = () => (
  <div className="flex size-10 items-center justify-center rounded-full bg-puntt-accent-7">
    <svg
      width="30"
      height="28"
      viewBox="0 0 30 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.4939 5.67486H15.8328V2.34435C15.8328 2.12352 15.7451 1.91174 15.589 1.75559C15.4328 1.59944 15.221 1.51172 15.0002 1.51172C14.7794 1.51172 14.5676 1.59944 14.4114 1.75559C14.2553 1.91174 14.1676 2.12352 14.1676 2.34435V5.67486H7.50654C6.62323 5.67486 5.7761 6.02576 5.15151 6.65035C4.52692 7.27494 4.17603 8.12207 4.17603 9.00538V20.6622C4.17603 21.5455 4.52692 22.3926 5.15151 23.0172C5.7761 23.6418 6.62323 23.9927 7.50654 23.9927H22.4939C23.3772 23.9927 24.2243 23.6418 24.8489 23.0172C25.4735 22.3926 25.8244 21.5455 25.8244 20.6622V9.00538C25.8244 8.12207 25.4735 7.27494 24.8489 6.65035C24.2243 6.02576 23.3772 5.67486 22.4939 5.67486ZM24.1591 20.6622C24.1591 21.1038 23.9837 21.5274 23.6714 21.8397C23.3591 22.152 22.9355 22.3274 22.4939 22.3274H7.50654C7.06489 22.3274 6.64132 22.152 6.32903 21.8397C6.01673 21.5274 5.84128 21.1038 5.84128 20.6622V9.00538C5.84128 8.56373 6.01673 8.14016 6.32903 7.82786C6.64132 7.51557 7.06489 7.34012 7.50654 7.34012H22.4939C22.9355 7.34012 23.3591 7.51557 23.6714 7.82786C23.9837 8.14016 24.1591 8.56373 24.1591 9.00538V20.6622Z"
        fill="#21201C"
      />
      <path
        d="M13.3333 13.1777H14.9999H16.6666"
        stroke="#21201C"
        strokeWidth="1.66667"
      />
      <path
        d="M12.5115 19.8447H15.0115H17.5115"
        stroke="#21201C"
        strokeWidth="1.66667"
        strokeLinecap="round"
      />
      <path
        d="M5 10.667L6.17851 11.8455L7.35702 13.024"
        stroke="#21201C"
        strokeWidth="1.66667"
        strokeLinecap="round"
      />
      <path
        d="M24.5947 10.667L23.5635 11.6982L22.5323 12.7294"
        stroke="#21201C"
        strokeWidth="1.66667"
        strokeLinecap="round"
      />
      <circle
        cx="10.428"
        cy="13.5947"
        r="2.91667"
        stroke="#21201C"
        strokeWidth="1.66667"
      />
      <circle
        cx="19.5947"
        cy="13.5947"
        r="2.91667"
        stroke="#21201C"
        strokeWidth="1.66667"
      />
      <rect
        x="1.67814"
        y="12.7614"
        width="3.33333"
        height="4.58333"
        stroke="#21201C"
        strokeWidth="1.66667"
        strokeLinejoin="round"
      />
      <rect
        x="25.0114"
        y="12.7614"
        width="3.33333"
        height="4.58333"
        stroke="#21201C"
        strokeWidth="1.66667"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);

export const ChatMessage = ({ message, setIsThinking }: ChatMessageProps) => {
  const { t } = useTranslation("ui");
  const [typedText, setTypedText] = useState("");
  useEffect(() => {
    let index = 0;
    const timer = setInterval(() => {
      if (index <= message.content.length) {
        setTypedText(message.content.slice(0, index));
        index++;
      } else {
        if (
          !THINKING_MESSAGES.includes(message.content) &&
          message.type != "user"
        ) {
          setIsThinking?.(false);
        }
        clearInterval(timer);
      }
    }, 25);

    return () => clearInterval(timer);
  }, []);
  if (message.type === "assistant") {
    return (
      <div className="flex gap-2.5">
        <RobotIcon />
        <Grid
          className="flex-1 items-start space-x-3 rounded-xl bg-puntt-accent-3 px-4 py-2"
          gap="2"
        >
          <Text size="3">{typedText}</Text>
          {message.evidence && (
            <>
              <Text size="2" weight="bold">
                {t("intro.chatMessage.sourceEvidence")}
              </Text>
              <div className="rounded-lg border border-puntt-neutral-gray-8 bg-puntt-neutral-gray-2 p-2">
                <Code size="1" weight="regular" variant="ghost">
                  {message.evidence}
                </Code>
              </div>
            </>
          )}
        </Grid>
      </div>
    );
  }

  return (
    <div className="flex justify-end">
      <div className="max-w-xs rounded-xl border border-puntt-accent-5 px-4 py-2">
        <Text size="3">{message.content}</Text>
      </div>
    </div>
  );
};
